import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const schedulingRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/scheduling",
  component: lazyRouteComponent(() => import("./scheduling.page.js"), "SchedulingPage"),
});
